import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightbox", "videoLightbox", "video"]
  static values = { promoVideoUrl: String }

  connect() {
    if (new URLSearchParams(window.location.search).get("video") === "1" && this.promoVideoUrlValue) {
      requestAnimationFrame(() => {
        window.scrollTo(0, 0)
        this.videoTarget.preload = "metadata"
        this.videoTarget.src = this.promoVideoUrlValue + "#t=0.001"
        this.videoLightboxTarget.classList.add("is-open")
        document.body.style.overflow = "hidden"
      })
    }

    this.boundSmoothScrollToWaitlist = this.smoothScrollToWaitlist.bind(this)
    document.addEventListener("click", this.boundSmoothScrollToWaitlist)
  }

  disconnect() {
    document.body.style.overflow = ""
    if (this.boundSmoothScrollToWaitlist) {
      document.removeEventListener("click", this.boundSmoothScrollToWaitlist)
    }
  }

  smoothScrollToWaitlist(event) {
    const link = event.target.closest('a[href="#waitlist"]')
    if (!link) return

    const target = document.getElementById("waitlist")
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  openLightbox(event) {
    const targetId = event.params.target
    const lightbox = document.getElementById(targetId)
    if (lightbox) lightbox.classList.add("is-open")
  }

  closeLightbox(event) {
    event.stopPropagation()
    event.target.closest(".video-lightbox").classList.remove("is-open")
  }

  closeLightboxBackground(event) {
    if (event.target === event.currentTarget) {
      event.currentTarget.classList.remove("is-open")
    }
  }

  openVideoLightbox(event) {
    const url = event.currentTarget.dataset.videoUrl
    if (!url) return

    this.videoTarget.src = url
    this.videoLightboxTarget.classList.add("is-open")
    this.videoTarget.play()
    document.body.style.overflow = "hidden"
  }

  closeVideoLightbox(event) {
    event.stopPropagation()
    this.#closeVideo()
  }

  closeVideoLightboxBackground(event) {
    if (event.target === event.currentTarget) this.#closeVideo()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  #closeVideo() {
    this.videoTarget.pause()
    this.videoTarget.src = ""
    this.videoLightboxTarget.classList.remove("is-open")
    document.body.style.overflow = ""
  }
}
